import browser from '@openclassrooms/utils/browser';
import getPathName from './getPathName';
import ROUTES from '../constants/routes';

const redirectToPath = (url, fallbackToDashboard) => {
  const fallback = fallbackToDashboard
    ? getPathName(ROUTES.SPACES.STUDENT.INDEX)
    : getPathName(ROUTES.HOMEPAGE.INDEX);

  if (!url) {
    browser.window.location.href = fallback;
    return;
  }

  if (url.startsWith('/') && !url.startsWith('//')) {
    browser.window.location.href = url;
    return;
  }

  try {
    const parsedUrl = new URL(url);
    browser.window.location.href = parsedUrl.pathname + parsedUrl.search;
  } catch {
    browser.window.location.href = fallback;
  }
};

export default redirectToPath;
